import Api from "../../../../src/util/Api";

export default function getInitState() {
  return {
    // varandosagMegallapitasEkatFields: [
    //   {
    //     name: "ellatoOrvos",
    //     label: "Ellátó orvos",
    //     visibility: false,
    //     formRequired: true,
    //     formType: "select",
    //     selectOptions: {
    //       apiCallback: Api.getAllDoctorForEeszt,
    //       formatText: function(val) {
    //         return val.text;
    //       },
    //       formatOption: function(val) {
    //         return val.text;
    //       },
    //       minimumInputLength: 0,
    //       searchOnServer: false,
    //       filteredAttr: "text",
    //       returnValue: "eesztId", 
    //       locale: {
    //         searchPlaceholder: "Keresés...",
    //         noResults: "Nincs találat",
    //       },
    //     },
    //     formSize: 4,
    //     formVisible: true,
    //     formReadOnly: true,
    //   },
    //   {
    //     name: "esemenyTipus",
    //     label: "Esemény típus",
    //     visibility: true,
    //     slot_name: "esemenyTipus_format",
    //     formType: "select",
    //     formSize: 4,
    //     formVisible: true,
    //     formRequired: true,
    //     formReadOnly: true,
    //     selectOptions: {
    //       apiCallback: Api.getEsemenyTipusAllList,
    //       formatText: function(val) {
    //         return val.text;            
    //       },
    //       formatOption: function(val) {
    //         return val.text;
    //       },
    //       minimumInputLength: 0,
    //       searchOnServer: false,
    //       filteredAttr: "text",
    //       returnValue: "eesztId",
    //       locale: {
    //         searchPlaceholder: "Keresés...",
    //         noResults: "Nincs találat",
    //       },          
    //     },
    //   },
    // ],
    varandosagMegallapitasFields: [
      {
        name: "terhessegiKorHet",
        label: "Terhességi kor hét",
        filter: {
          type: "simple"
      },
        visibility: true,
        formType: "number",
        formVisible: true,
        formRequired: true,
      },
      
      {
        name: "terhessegiKorNap",
        label: "Terhességi kor nap",
        visibility: true,
        formType: "number",
        formVisible: true,
        formRequired: true,
      },
      {
        name: "rizikoBesorolasId",
        label: "Rizikó besorolás",
        visibility: false,
        formType: "select",
        formSize: 4,
        formVisible: true,
        formRequired: true,
        selectOptions: {
          apiCallback: Api.getPregnancyRisks,
          formatText: function(val) {
            return val.text;
          },
          formatOption: function(val) {
            return val.text;
          },
          minimumInputLength: 0,
          searchOnServer: false,
          filteredAttr: "text",
          returnValue: "id",
          locale: {
            searchPlaceholder: "Keresés...",
            noResults: "Nincs találat",
          },
        },
      },
      {
        name: "breakGlass",
        label: "Sürgősségi adatlekérés",
        formType: "checkbox",
        formSize: 4,
        ignoreOnTextGeneration: true,
      },
      {
        name: "r1",
        label:
          "Az anya kora (születési dátum alapján) 40 felett vagy 18 év alatt magas kockázatú",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r2",
        label:
          "A terhesség kora hetekben a jelentkezéskor (14 felett magas kockázatú)",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r3",
        label: "Hányadik szülés? 4 feletti? (magas kockázatú)",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r4",
        label: "Pszihoszociális helyzet",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r5",
        label:
          "Rendszeresen fogyaszt alkoholt, drogfogyasztó vagy dohányzik (naponta 10 szálnál többet)",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r6",
        label: "HIV vagy hepatitis B, C fertőzés",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r7",
        label: "BMI indexe 18 alatt vagy 30 felett",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r8",
        label:
          "Krónikus hypertonia-betegség, szív- és érrendszeri megbetegedés",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r9",
        label:
          "Endokrin betegség (diabetes, hyperthyreosis, hypothyreosis, PCO)",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r10",
        label:
          "Krónikus gastrointestinalis, máj-, tüdő-, (súlyos asthma), vesebetegség",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r11",
        label:
          "Idegrendszeri- és (kezelést igénylő) pszichiátriai megbetegedés (pl. epilepsia, schizophrenia, depressio)",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r12",
        label:
          "Haematológiai, autoimmun, thromboemboliás betegség, antiphospholipid sy",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r13",
        label: "Daganatos megbetegedések",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r14",
        label: "Genetikai betegségek a családban",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r15",
        label: "Ikerterhesség, többes iker",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r16",
        label: "Vérzés a jelen terhességben (fenyegető vetélés)",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r17",
        label: "Habituális vetélés",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r18",
        label: "Méhen végzett műtét, császármetszés, conizáció",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r19",
        label: "Koraszülés",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r20",
        label: "Praeeclampsia, HELLP syndroma",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r21",
        label: "Rh(D)-Isoimmunisatio",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r22",
        label: "Magzati restrikció",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r23",
        label: "Gestatios diabetes",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r24",
        label: "Újszülött súlya 4500 g feletti",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "r25",
        label: "Perinatális halálozás ismeretlen okból",
        visibility: true,
        formType: "checkbox",
        formVisible: true,
      },
      {
        name: "description",
        label: "Megjegyzés",
        visibility: true,
        formType: "textarea",
        formVisible: true,
      },
     
    ],
  };
}
